import { render, staticRenderFns } from "./PictureInput.vue?vue&type=template&id=37b532b7&scoped=true"
import script from "./PictureInput.vue?vue&type=script&lang=js"
export * from "./PictureInput.vue?vue&type=script&lang=js"
import style0 from "./PictureInput.vue?vue&type=style&index=0&id=37b532b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b532b7",
  null
  
)

export default component.exports